import { useState } from "react";
import AdminLogin from "./AdminLogin";
import RegistrationsAdmin from "./RegistrationsAdmin";
import { getAdminSession, logoutAdmin } from "../../utils/adminAuth";
import "../../styles/components/AdminApp.css";

export default function AdminApp() {
  const [session, setSession] = useState(getAdminSession);
  const roleLabel = session?.role ?? "";

  if (!session) {
    return (
      <div className="admin">
        <div className="container admin__container">
          <AdminLogin onLogin={setSession} />
        </div>
      </div>
    );
  }

  return (
    <div className="admin">
      <header className="admin__header">
        <div className="container admin__headerInner">
          <div>
            <div className="admin__title">Admin</div>
            <div className="admin__subtitle">Chicago DC 2026 RSVP</div>
          </div>
          <div className="admin__headerActions">
            <div className="admin__role" aria-label="Signed in role">
              {roleLabel}
            </div>
            <button
              className="admin__button admin__button--secondary"
              type="button"
              onClick={() => {
                logoutAdmin();
                setSession(null);
              }}
            >
              Log out
            </button>
          </div>
        </div>
      </header>

      <main className="container admin__container">
        <RegistrationsAdmin />
      </main>
    </div>
  );
}

